import * as React from 'react';
import Chart from '../images/key-features/Chart.svg';
import Controls from '../images/key-features/Controls.svg';
import EmailContactSales from '../components/EmailContactSales';
import Gauge from '../images/key-features/Gauge.svg';
import Gear from '../images/key-features/Gear.svg';
import GuyChartsPlants from '../images/key-features/guyChartsPlants.svg';
import Layout from '../components/Layout';
import LightBulb from '../images/key-features/LightBulb.svg';
import MoneyBag from '../images/key-features/MoneyBag.svg';
import Phone from '../images/credit-cards/phone.svg';
import ShieldLock from '../images/key-features/ShieldLock.svg';
import circleBlueGears from '../images/icons/circle-blue-gears.png';
import headerGradient from '../images/key-features/headerGradient.png';
import radialGradient from '../images/radialShadow.jpg';
import styled from 'styled-components';
import WantToSeeHow from '../components/WantToSeeHow';
import AngleRight from '../components/AngleRight';
import { FaCheck } from 'react-icons/fa';

const Section = styled.section`

	&.centered-text:first-child h3 {
		@media (${(props) => props.theme.largeUp}) {
			max-width: 950px;
		}
	}

	&.two-rounded-boxes {
		align-items: stretch;
		padding-top: 0;
		padding-bottom: 0;

		& .rounded-box {
			max-width: 320px;
			margin-left: auto;
			margin-right: auto;
			margin-bottom: 3em;
			padding: 2em 2em;

			& h2 {
				margin-left: 0;
				line-height: 1.5;
			}

			@media (${(props) => props.theme.mediumUp}) {
				max-width: 550px;
			}
		}

		& header {
			align-items: flex-end;
		}

		& article {
			display: flex;
			align-items: stretch;
		}
	}

	&.secure-compliant {
		padding-bottom: 1em;

		& article.circle-figures {
			margin-top: 3em;
			display: flex;
			flex-direction: column;
			justify-content: space-around;
			padding-right: 0;
			padding-left: 0;

			@media (${props => props.theme.mediumUp}) {
				flex-direction: row;
			}

			& figure.circle {
				justify-content: center;
				margin-left: 1em;
				margin-right: 1em;
				margin-bottom: 3em;

				& h3 {
					color: white;
					justify-content: center;
					align-items: center;
					display: flex;
				}

				&.experian h3 {
					background: #41a9c5;
				}

				&.security h3 {
					background: #81e2b6;
				}

				&.pci h3 {
					background: #35b380;
					font-weight: 900;
					line-height: 33px;
					flex-direction: column;
				}
			}

			& figcaption {
				max-width: 170px;
				margin: 0 auto;

				& a {
					white-space: nowrap;
				}
			}

			& h3 {
				width: 136px;
				height: 136px;
				line-height: 136px;
				padding: 0;
				border-radius: 68px;
				display: block;
				font-size: 40px;
				margin: 0 auto 20px;
			}
		}

		@media (${props => props.theme.mediumUp}) {
			align-items: center;
		}
	} // Section.secure-compliant
`;

const RadialGradient = styled.div`
	@media (${(props) => props.theme.mediumUp}) {
		background-image: ${(props) => `url('${radialGradient}')`};
		background-size: 100% 100%;
		background-position: center center;
		max-width: 1366px;
		margin-left: auto;
		margin-right: auto;
		padding-top: 2em;
		padding-bottom: 4em;
	}
`;

const HeaderContentArticle = styled.article`
	color: white;

	& h1 {
		background-image: none;

		@media (${(props) => props.theme.mediumUp}) {
			background-image: ${(props) => `url('${circleBlueGears}')`};
			background-repeat: no-repeat;
			background-position: right center;
			// min-height: 113px;
			width: 350px;
		}
	}

	p br {
		display: none;

		@media (${(props) => props.theme.smallUp}) {
			display: block;
		}
	}
`;

const HeaderBottomContentFigure = styled.figure`
	background: transparent;
	margin-bottom: 1em;
`;

const keyFeaturesHeaderContentArticle =
	<HeaderContentArticle>
		<h1>Key<br />Features</h1>
		<p className='bigger'>A complete loan origination platform <br />built for growth</p>
		<EmailContactSales />
	</HeaderContentArticle>
;

const guyChartsPlantsFigure =
	<HeaderBottomContentFigure>
		<GuyChartsPlants alt='Main looking at web app widgets' />
	</HeaderBottomContentFigure>
;

const WantToSeeHowStyle = { paddingBottom: '4em' };

const KeyFeaturesIndex = (props: any) => {
	return (
	<Layout
		headerBottomContent={guyChartsPlantsFigure}
		headerContent={keyFeaturesHeaderContentArticle}
		headerSplashBg={headerGradient}
		headerSplashBgAverageColor={'#6a758a'}
		metaDescription={"Key features of MK Decision's lending products"}
		pageTitle='Key Features | loan origination products '
		skipMoney2020={true}
		BodyClass={'key-features UseCases'}
	>
		<div className='centeredWrapper'>
			<Section className='centered-text'>
				<h2>Mobile-first products &amp; lending solutions for financial institutions</h2>
				{/* <h3>Our products include advanced features to enhance customer relationships and ensure program success. Here are a few key product features:</h3> */}
			</Section>
			<RadialGradient>
				<Section className='two-rounded-boxes row row-flush centered'>
					<article className='col-12 col-md-6'>
						<div className='rounded-box left-aligned'>
							<header>
								<LightBulb alt='Lightbulb' />
								<h2>Digital<br />Marketing Strategy</h2>
							</header>
							<p>Content is the fuel that powers online lending. Your website needs to present the right messaging for customers to borrow online. We deploy responsive marketing pages for your loan offers that help you educate and inform your customers.</p>
						</div>
					</article>
					<article className='col-12 col-md-6'>
						<div className='rounded-box left-aligned'>
							<header>
								<Phone alt='Smart Phone' />
								<h2>Mobile First<br />Customer Experience</h2>
							</header>
							<p>More than 70% of the credit applications we receive are processed from a borrower's smartphone. MK's customer-facing marketing pages and application flows are designed for mobile phones first.</p>
						</div>
					</article>
				</Section>
				<Section className='two-rounded-boxes row row-flush centered'>
					<article className='col-12 col-md-6'>
						<div className='rounded-box left-aligned'>
							<header>
								<ShieldLock alt='Security Shield' />
								<h2>Fraud<br />Prevention</h2>
							</header>
							<p>Fraud is on the rise. With identity theft up 33% from 5 years ago, MK has created two fraud prevention products to identify, track, and prevent fraudulent applications.</p>
						</div>
					</article>
					<article className='col-12 col-md-6'>
						<div className='rounded-box left-aligned'>
							<header>
								<Gear alt='Gear' />
								<h2>Automated<br />Decisioning Engine</h2>
							</header>
							<p>Decision credit in seconds. In the age of automation, borrowers do not want to wait for credit decisions. MK's core business was built around our credit decisioning engine that is easily configured to your internal underwriting guidelines.</p>
						</div>
					</article>
				</Section>
				<Section className='two-rounded-boxes row row-flush centered'>
					<article className='col-12 col-md-6'>
						<div className='rounded-box left-aligned'>
							<header>
								<Controls alt='Settings controls' />
								<h2>Advanced<br />Technology Integrations</h2>
							</header>
							<p>To reduce manual data entry and human error, MK integrates with credit bureaus, core processors, and alternative data providers. We can handle any API integration required by a client to ensure your lending platform is truly end-to-end.</p>
						</div>
					</article>
					<article className='col-12 col-md-6'>
						<div className='rounded-box left-aligned'>
							<header>
								<MoneyBag alt='Money bag' />
								<h2>Support for <br />All Loan Types</h2>
							</header>
							<p>Loan processing efficiency is essential to organizational success. As a result, we developed our lending platform to accept all loan types so that your loan officers will never need different systems for different loan types again.</p>
						</div>
					</article>
				</Section>
				<Section className='two-rounded-boxes row row-flush centered'>
					<article className='col-12 col-md-6'>
						<div className='rounded-box left-aligned'>
							<header>
								<Gauge alt='Speedometer' />
								<h2>Lending<br />Dashboard</h2>
							</header>
							<p>We bring efficiency to loan origination and simplicity to your customer relationship with our dashboard. Increase loan processing performance via our digital solution and focus on customer connectivity to help your borrowers achieve their financial goals.</p>
						</div>
					</article>
					<article className='col-12 col-md-6'>
						<div className='rounded-box left-aligned'>
							<header>
								<Chart alt='Analytics Chart' />
								<h2>Big Data<br />Analytics</h2>
							</header>
							<p>Make data-driven decisions with MK's suite of reports to measure your loan portfolio. Track borrower activity on your lending web pages with both Google Analytics and Mixpanel. Need a custom report? Let us know.</p>
						</div>
					</article>
				</Section>
			</RadialGradient>
			<Section className='centered-text secure-compliant'>
				<h2>Secure and compliant from lender to borrower</h2>
				<h3>
					Data security is extremely important to MK. We are continuously
					updating our platform to satisfy the demanding requirements of the
					lending environment. We invest extensively to secure our
					technology in partnership with leading security experts.
				</h3>
				<article className='circle-figures'>
					<figure className='experian circle'>
						<h3>EI3PA</h3>
						<figcaption>
							Experian{' '}
							<a
								href='http://www.experian.com/assets/corporate/technical-providers/authorized-technical-providers.pdf'
								className='animate-right'
							>
								technical provider
								<AngleRight />
							</a>
						</figcaption>
					</figure>
					<figure className='security circle'>
						<h3>$5M</h3>
						<figcaption>Data security insurance coverage</figcaption>
					</figure>
					<figure className='pci circle'>
						<h3>
							<FaCheck />
							PCI
						</h3>
						<figcaption>PCI DSS Level 1 certification</figcaption>
					</figure>
				</article>
			</Section>
			<WantToSeeHow extraStyle={WantToSeeHowStyle} />
		</div>
	</Layout>
	);
};

export default KeyFeaturesIndex;
